import { useState } from "react";
import styles from "./styles.module.scss";
import img1 from "./img/img1.png";
import img2 from "./img/img2.png";
import img3 from "./img/img3.png";
import img4 from "./img/img4.png";
import img5 from "./img/img5.png";

import { SOMATIC_KEYS } from "../../../../shared";

import { IconCardCheckbox } from "../../../../shared";
import { Button } from "../../../../../../common";
import { WALKY_KEYS } from "src/routes/onboarding/shared/constants/walkyKeys";
import { CheckWithImageWalky } from "src/routes/onboarding/shared/components/checkWithImageWalky";

const data = [
  {
    value: "WEIGHT_LOSS",
    displayValue: "Lose weight",
    img: img1,
  },
  {
    value: "IMPROVE_HEART",
    displayValue: "Improve heart health",
    img: img2,
  },
  {
    value: "GET_TONED",
    displayValue: "Get firm and toned",
    img: img3,
  },
  {
    value: "DE_STRESS",
    displayValue: "Relieve stress",
    img: img4,
  },
  {
    value: "LOWER_AGE",
    displayValue: "Lower biologocal age",
    img: img5,
  },
];

export const WhatDoYouWantToAchive = ({ onNextStep, onTrackEvent }) => {
  const [checked, setChecked] = useState(() => {
    const saved = localStorage.getItem(WALKY_KEYS.hopeToAchieve);
    return saved ? JSON.parse(saved) : [];
  });

  const handleCheck = (value) => {
    setChecked((prevState) => {
      const newState = prevState.includes(value)
        ? prevState.filter((item) => item !== value)
        : [...prevState, value];

      localStorage.setItem(WALKY_KEYS.hopeToAchieve, JSON.stringify(newState));
      return newState;
    });
  };

  const handleNextStep = () => {
    console.log("here 2", checked, "answer qqWalkingGoal");

    let answer = null;

    if (checked.includes("WEIGHT_LOSS")) {
      answer = "WEIGHT_LOSS";
    } else if (checked.length > 0) {
      answer = checked[0];
    }

    if (answer) {
      onNextStep(answer);
      onTrackEvent(answer);
    }
  };

  return (
    <div className={styles.container}>
      <div className={styles.content}>
        <h2>What do you want to achieve?</h2>
        <p>You can select multiple goals</p>
        <div className={styles.cards}>
          {data.map((value) => (
            <CheckWithImageWalky
              checked={checked.includes(value.value)}
              onClick={() => handleCheck(value.value)}
              img={value.img}
              title={value.displayValue}
              key={value.value}
            />
          ))}
        </div>
      </div>
      <div className={styles.action}>
        <Button
          variant="walky"
          disabled={!checked.length}
          onClick={handleNextStep}
        >
          Continue
        </Button>
      </div>
    </div>
  );
};
